import React, { useState } from 'react';
import axios from 'axios';
import { TextInput, Button, Alert } from '@opendate-app/setlist';

const PANEL_STYLE = {
  padding: 12,
  backgroundColor: 'var(--sl-bg-tertiary)',
  border: '1px solid var(--sl-border-secondary)',
  borderRadius: 8,
  marginTop: 8,
};

const GRID_STYLE = { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 };

function seedFromQuery(query) {
  const text = (query || '').trim();
  if (text.includes('@')) return { firstName: '', lastName: '', email: text };
  const [firstName = '', ...rest] = text.split(/\s+/);
  return { firstName, lastName: rest.join(' '), email: '' };
}

function ContactQuickCreateForm({ team, csrfToken, initialQuery = '', onCreated, onCancel }) {
  const seed = seedFromQuery(initialQuery);
  const [firstName, setFirstName] = useState(seed.firstName);
  const [lastName, setLastName] = useState(seed.lastName);
  const [email, setEmail] = useState(seed.email);
  const [phone, setPhone] = useState('');
  const [saving, setSaving] = useState(false);
  const [errors, setErrors] = useState([]);

  const canSubmit = firstName.trim().length > 0 && (email.trim().length > 0 || phone.trim().length > 0) && !saving;

  const handleCreate = async (e) => {
    e.preventDefault();
    if (!canSubmit || !team || !team.id) return;
    try {
      setSaving(true);
      setErrors([]);
      if (csrfToken) axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
      const response = await axios.post(`/teams/${team.id}/crm/fans.json`, {
        fan: {
          first_name: firstName.trim(),
          last_name: lastName.trim() || null,
          email: email.trim() || null,
          phone_number: phone.trim() || null,
        },
      });
      onCreated(response.data);
    } catch (e) {
      const data = e.response && e.response.data;
      setErrors(Array.isArray(data) ? data : ['Failed to create contact.']);
      setSaving(false);
    }
  };

  return (
    <form style={PANEL_STYLE} onSubmit={handleCreate}>
      {errors.length > 0 && (
        <div style={{ marginBottom: 8 }}>
          <Alert color="error" description={errors.join(', ')} />
        </div>
      )}
      <div style={GRID_STYLE}>
        <TextInput size="sm" label="First name" required value={firstName} onChange={(e) => setFirstName(e.target.value)} />
        <TextInput size="sm" label="Last name" value={lastName} onChange={(e) => setLastName(e.target.value)} />
        <TextInput size="sm" label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
        <TextInput size="sm" label="Phone" type="tel" value={phone} onChange={(e) => setPhone(e.target.value)} />
      </div>
      <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 8 }}>
        <Button variant="secondary" size="sm" onClick={onCancel} disabled={saving}>
          Cancel
        </Button>
        <Button type="submit" variant="primary" size="sm" disabled={!canSubmit}>
          {saving ? 'Creating…' : 'Create contact'}
        </Button>
      </div>
    </form>
  );
}

export default ContactQuickCreateForm;
